import { Factsheet } from '@bepatient/factsheet-store';
import { Action } from '@ngrx/store';

export enum FactsheetActionTypes {
  LOAD_FACTSHEET = '[FactsheetAction] Load Factsheet',
  LOAD_FACTSHEET_FAILED = '[FactsheetAction] Load Factsheet failed',
  LOAD_FACTSHEET_SUCCESS = '[FactsheetAction] Load Factsheet success',
  NEXT_BUTTON_CLICKED = '[FactsheetAction] Next button factsheet'
}

export class FactsheetActionLoadFactsheet implements Action {
  readonly type = FactsheetActionTypes.LOAD_FACTSHEET;
}

export class FactsheetActionLoadFactsheetFailed implements Action {
  readonly type = FactsheetActionTypes.LOAD_FACTSHEET_FAILED;
}

export class FactsheetActionLoadFactsheetSuccess implements Action {
  readonly type = FactsheetActionTypes.LOAD_FACTSHEET_SUCCESS;

  constructor(public payload: Factsheet) {}
}

export class FactsheetActionNextButtonFactsheet implements Action {
  readonly type = FactsheetActionTypes.NEXT_BUTTON_CLICKED;

  constructor(public payload: any) {}
}

export type FactsheetActions =
  | FactsheetActionLoadFactsheet
  | FactsheetActionLoadFactsheetFailed
  | FactsheetActionLoadFactsheetSuccess
  | FactsheetActionNextButtonFactsheet;
